<template>
    <div>
        <el-dialog :title="title" :visible.sync="videoflag">
            <el-card class="box-card" style="margin-bottom:10px;">
                <div v-for="item in videolist" :key="item" class="text item">
                    <audio :src="item" v-if="type=='mp3'" controls="controls"></audio>
                    <video :src="item" controls="controls" v-else style="width: 49%;height:400px;float:left;margin-right:1%;"> </video>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>
<script>
import {getImgLink} from '@/config/env'
    export default {
        data() {
            return {
                videoflag : false,
                videolist : [],
                videos : '',
                title : '',
                type :''
            }
        },
        created() {},
       
        methods: {
            //设置展示
             viderstate(data,type){
                this.videoflag = true;
                this.type = type;
                this.title = (type=="mp3"?'音频播放':'视频播放');
                this.videos = data.split(',');
                this.getfeedback(this.videos);
            },
            getfeedback(data){
                for(var i=0;i<data.length;i++){
                    data[i] = getImgLink(data[i]);
                }
                this.videolist =data;
            },
           
        }
    }
</script>